import { ChipTypeMap } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import { useQuery } from '../../request/hooks/useQuery';
import { Autocomplete, AutocompleteProps } from '../Autocomplete/Autocomplete';
import { EntityUIState } from '../../request/interfaces/entity-ui-state';
import { getDataIdGenerator } from '../../shared/utils/dataId';

export function AsyncAutocomplete<
  A,
  B extends boolean | undefined,
  C extends boolean | undefined,
  D extends boolean | undefined,
  E extends React.ElementType = ChipTypeMap['defaultComponent']
>(
  props: AutocompleteProps<A, B, C, D, E> & {
    dataSource: (params: unknown) => Promise<unknown>;
  }
) {
  const AutocompleteWithTsFixes = Autocomplete as (
    props: AutocompleteProps<A, B, C, D, E>
  ) => ReactNode;
  const { dataSource, dataId, ...rest } = props;
  const {
    data: options = [],
    uiState,
    error,
    fetch
  } = useQuery({
    dataSource$: dataSource
  });

  useEffect(() => {
    fetch();
  }, [dataSource]);

  const dataIdGenerator = getDataIdGenerator('async', dataId);

  return (
    <AutocompleteWithTsFixes
      {...rest}
      dataId={dataIdGenerator('')}
      options={options as A[]}
      loading={uiState === EntityUIState.LOADING}
      noOptionsText={error ? 'Something went wrong' : 'No options found'}
    />
  );
}
